import { render, staticRenderFns } from "./AddRevisionForm.vue?vue&type=template&id=0bd796fe&"
import script from "./AddRevisionForm.vue?vue&type=script&lang=js&"
export * from "./AddRevisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports